import * as React from 'react';
import {renderElement} from '../../../../utils';
import {useNumberInputContext} from '../../_context';

import {NumberInputPrefixView} from './NumberInputPrefix.styles';

export const NumberInputPrefix = () => {
  const {state} = useNumberInputContext();

  if (!state.prefix) return null;

  const prefix =
    typeof state.prefix === 'string'
      ? state.prefix
      : renderElement(state.prefix);

  return <NumberInputPrefixView>{prefix}</NumberInputPrefixView>;
};
